import clsx from "clsx";

// ButtonHTMLAttributes rather than HTMLAttributes: the narrower type omitted
// `type`, `disabled` and `form`, so a caller could not mark this as a submit
// button without casting. LoginForm relies on the browser default (submit), so
// no default is set here — widening only removes the need for the cast.
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

/** Primary action button. Extra classes are merged after the base styling, so callers can override it. */
export default function Button({ className, children, ...rest }: ButtonProps) {
  return (
    <button
      className={clsx(
        "rounded bg-indigo-500 px-3 py-2 font-medium text-slate-200 transition-colors hover:bg-indigo-600",
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
